import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { ArticleTextileType, CommonResponseModel, ImageUplaodReq, MeasurementDataReq, StatusApprovalsEnum, StyleStautsReq, TrimCardStatusEnum, TrimCardUpdateReq, UnitTwelevePdfReq, WFXAndVersionsIdReqDto, WFXIdReqDto, WFXRolesEnum, WFXStatusEnum, WfxCarharttEnum } from "@project-management-system/shared-models";
import * as fs from 'fs';
import { DataSource, In, Repository } from "typeorm";
import { GenericTransactionManager } from "../../typeorm-transactions";
import { BuyerEntity } from "./dto/buyer-entity";
import { MeasurementDataShahiCarharttEntity } from "./dto/color-carhartt.entity";
import { WfxImageUploadEntity } from "./dto/file-upload-entity";
import { MeasurementDataEntity } from "./dto/measurement-data-entity";
import { ParameterEntity } from "./dto/parameter-entity";
import { StylesEntity } from "./dto/style-carhartt.entity";
import { StylesDto } from "./dto/styles-dto";
import { UnitTweleveExcelDataEntity } from "./dto/unit-twelve-excel.entity";
import { UnitTwelevFileUploadEntity } from "./dto/unit-twleve-file.entity";
import { WfxFileUploadEntity } from "./dto/wfx-file.entity";
import { WFXStatusWiseReqDto } from "./dto/wfx-status-wise-req.dto";
import { ApparelArticleMaster } from "./entities/tech-pack/apparel-article-master.entity";
import { FabricTrimsMaster } from "./entities/tech-pack/fabric-trims-master.entity";
import { MeasurementChart2T } from "./entities/tech-pack/measurement-chart-2t.entity";
import { MeasurementChartMonths } from "./entities/tech-pack/measurement-chart-6-12-months.entity";
import { ApparelArticleMasterRepo } from "./repositories/apparel-article-master.repo";
import { BuyerRepo } from "./repositories/buyer-repo";
import { ColorCarharttRepository } from "./repositories/color-carhartt-repo";
import { FabricTrimsMasterRepo } from "./repositories/fabric-trims-master.repo";
import { ImagesRepo } from "./repositories/images-repo";
import { MeasurementChart2TRepo } from "./repositories/measurement-chart-2t.repo";
import { MeasurementChartMonthsRepo } from "./repositories/measurement-chart-months.repo";
import { ParameterRepo } from "./repositories/parameter-repo";
import { StyleRepo } from "./repositories/style-repo";
import { UnitTweleveExcelRepo } from "./repositories/unit-tweleve-excel-repo";
import { UnitTwelveRepo } from "./repositories/unit-twleve-repo";
import { WfxRepository } from "./repositories/wfx-file-repo";
import { WFXAdapter } from "./wfx-adapter";
import { ApparelArticleMasterVersionsRepo } from "./repositories/versions-repos/apparel-article-master.repo";
import { ApparelArticleMasterVersions } from "./entities/tech-pack-versions/apparel-article-masters-versions.entity";
import { FabricTrimsMasterVersions } from "./entities/tech-pack-versions/fabric-trims-master-versions.entity";
import { MeasurementChart2TVersions } from "./entities/tech-pack-versions/measurement-chart-2t-versions.entity";
import { MeasurementChartMonthsVersions } from "./entities/tech-pack-versions/measurement-chart-6-12-months-versions.entity";
@Injectable()
export class WfxService {
  constructor(
    private WfxFileRepo: WfxRepository,
    private ColorCarharttRepo: ColorCarharttRepository,

    @InjectRepository(WfxImageUploadEntity)
    private fileRepo: Repository<WfxImageUploadEntity>,

    @InjectRepository(MeasurementDataEntity)
    private measurementRepo: Repository<MeasurementDataEntity>,

    private styleRepo: StyleRepo,
    private dataSource: DataSource,
    private buyerRepo: BuyerRepo,
    private parameterRepo: ParameterRepo,
    private imagesRepo: ImagesRepo,
    private unitTwelveRepo: UnitTwelveRepo,
    private unittweleveexcelRepo: UnitTweleveExcelRepo,
    private apparelAMrepo: ApparelArticleMasterRepo,
    private fabricTrimsMasterRepo: FabricTrimsMasterRepo,
    private WFXAdapter: WFXAdapter,
    private versionsApparelRepo: ApparelArticleMasterVersionsRepo
  ) { }

  async updatePath(files: Express.Multer.File[], excelFileName: string, pdfFileName: string, pdfFile: Express.Multer.File, randomId: any, dropDown: any): Promise<CommonResponseModel> {
    console.log(files, "files");
    console.log(pdfFile, "pdfFile");
    try {
      const entities = [];

      for (const file of files) {
        let entity;

        if (file.mimetype === 'application/pdf') {
          entity = new WfxFileUploadEntity();
          const regex = file.path
          entity.randomId = randomId;
          entity.pdfFileName = pdfFileName;
          entity.pdfFile = file.path;
          entity.originalFileName = regex.match(/upload_files_pdf.+/)[0].replace(/(upload_files_pdf.|upload_files_pdf.\s+)/g, "")
          entity.createdUser = "admin";
          entity.dropDown = dropDown
          entities.push(entity);
        }
        else if (file.mimetype === 'application/octet-stream') {
          const randomIdRecord = await this.updateExcelpath(randomId)
          console.log(randomIdRecord, "randomIdRecord")
          if (randomIdRecord) {
            randomIdRecord.filePath = file.path;
            randomIdRecord.excelFileName = excelFileName;
            entities.push(randomIdRecord);
          }
        }
      }

      const uploadedFiles = await this.WfxFileRepo.save(entities);
      if (uploadedFiles) {
        return new CommonResponseModel(true, 11, 'Uploaded successfully', files);
      } else {
        return new CommonResponseModel(false, 11, 'Upload failed', files);
      }
    } catch (error) {
      console.log(error);
      return new CommonResponseModel(false, 11, 'Error uploading files', files);
    }
  }

  async updateExcelpath(randomId: any): Promise<WfxFileUploadEntity> {
    const randomIdRecord = await this.WfxFileRepo.findOne({ where: { randomId: randomId } });
    if (!randomIdRecord) {
      return this.updateExcelpath(randomId)
    }
    return randomIdRecord
  }

  async updateUnitTwelvePath(files: Express.Multer.File[], excelFileName: string, pdfFileName: string, pdfFile: Express.Multer.File, randomId: any, dropDown: any, soNumber: any): Promise<CommonResponseModel> {
    console.log(files, "files");
    console.log(pdfFile, "pdfFile");
    try {
      const entities = [];
      for (const file of files) {
        let entity;
        if (file.mimetype === 'application/pdf') {
          entity = new UnitTwelevFileUploadEntity();
          const regex = file.path
          entity.randomId = randomId;
          entity.pdfFileName = pdfFileName;
          entity.pdfFile = file.path;
          entity.originalFileName = regex.match(/upload_files_pdf.+/)[0].replace(/(upload_files_pdf.|upload_files_pdf.\s+)/g, "")
          entity.createdUser = "admin";
          entity.dropDown = dropDown
          entity.soNumber = soNumber
          entities.push(entity);
        }
        else if (file.mimetype === 'application/octet-stream') {
          const randomIdRecord = await this.updateUnitTweleveRandomId(randomId)
          console.log(randomIdRecord, "randomIdRecord")
          if (randomIdRecord) {
            randomIdRecord.filePath = file.path;
            randomIdRecord.excelFileName = excelFileName;
            entities.push(randomIdRecord);
          }
        }
      }

      const uploadedFiles = await this.unitTwelveRepo.save(entities);
      if (uploadedFiles) {
        return new CommonResponseModel(true, 11, 'Uploaded successfully', files);
      } else {
        return new CommonResponseModel(false, 11, 'Upload failed', files);
      }
    } catch (error) {
      console.log(error);
      return new CommonResponseModel(false, 11, 'Error uploading files', files);
    }
  }

  async updateUnitTweleveRandomId(randomId: any): Promise<UnitTwelevFileUploadEntity> {
    const randomIdRecord = await this.unitTwelveRepo.findOne({ where: { randomId: randomId } });
    if (!randomIdRecord) {
      return this.updateUnitTweleveRandomId(randomId)
    }
    return randomIdRecord
  }

  async getPdfFileInfo(req: any): Promise<CommonResponseModel> {
    try {
      const data = await this.WfxFileRepo.getPDFInfo(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getUnitTwelvePDFInfo(req: any): Promise<CommonResponseModel> {
    try {
      const data = await this.unitTwelveRepo.getUnitTwelvePDFInfo(req)
      if (data) {
        return new CommonResponseModel(true, 1, 'data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async getAllUnitTwelvePDFData(req: UnitTwelevePdfReq): Promise<CommonResponseModel> {
    try {
      let query = `SELECT utefp.id AS id,
                     utefp.excel_file_name AS excelFileName, 
                     utefp.excel_file_path AS filePath, 
                     utefp.pdf_file_name AS pdfFileName, 
                     utefp.original_file_name AS originalFileName, 
                     utefp.pdf_file AS pdfFile, 
                     utefp.buyer_name AS dropDown, 
                     utefp.so_number AS soNumber, 
                     utefp.created_at AS createdAt, 
                     utefp.created_user AS createdUser, 
                     utefp.updated_at AS updatedAt
                     FROM unit_twleve_file_upload utefp
                     WHERE 1=1`;

      if (req.soNumber) {
        query += ` AND utefp.so_number = '${req.soNumber}'`;
      }
      console.log(req.soNumber, "SouNumber");

      if (req.dropDown) {
        query += ` AND utefp.buyer_name = '${req.dropDown}'`;
      }
      console.log(req.dropDown, 'BuyerName');

      const data = await this.unitTwelveRepo.query(query);
      console.log(data, "data");

      if (data) {
        return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getAllUnitTwelveData(): Promise<CommonResponseModel> {
    try {
      let query = `SELECT utefp.id AS id,
                     utefp.excel_file_name AS excelFileName, 
                     utefp.excel_file_path AS filePath, 
                     utefp.pdf_file_name AS pdfFileName, 
                     utefp.original_file_name AS originalFileName, 
                     utefp.pdf_file AS pdfFile, 
                     utefp.buyer_name AS dropDown, 
                     utefp.so_number AS soNumber, 
                     utefp.created_at AS createdAt, 
                     utefp.created_user AS createdUser, 
                     utefp.updated_at AS updatedAt
                     FROM unit_twleve_file_upload utefp `;

      const data = await this.unitTwelveRepo.query(query);
      console.log(data, "data");

      if (data) {
        return new CommonResponseModel(true, 1, 'Data retrieved successfully', data);
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', []);
      }
    } catch (err) {
      throw err;
    }
  }




  async fileSave(filesData: any[], createdUser: string, id: number, buyer: any, parameter: any): Promise<CommonResponseModel> {
    try {
      const fileEntities: WfxImageUploadEntity[] = [];
      filesData.forEach((file, index) => {
        const fileObj = new WfxImageUploadEntity();
        const fileEntityKeys = Object.keys(file);
        Object.keys(file).forEach((key) => {
          if (fileEntityKeys.includes(key)) {
            fileObj[key] = file[key];
          }
        });
        fileObj.id = id;
        fileObj.buyer = buyer;
        fileObj.parameter = parameter;
        fileObj.fileName = file.filename;
        fileObj.originalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.modifiedOriginalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.filePath = file.path;
        fileObj.createdUser = createdUser;
        fileObj.status = TrimCardStatusEnum.OPEN;
        fileEntities.push(fileObj);
        console.log(fileObj, "fileObj");

      });
      const save = await this.fileRepo.save(fileEntities);
      return new CommonResponseModel(true, 65433, "FileUploaded Successfully", save);
    } catch (error) {
      for (const file of filesData) {
        const filesDestination = './files';
        const filePath = `${filesDestination}/${file.uid}.${file.name.substring(
          file.name.lastIndexOf('.') + 1
        )}`;
        if (fs.existsSync) {
          fs.unlinkSync(filePath);
        }
      }
      return new CommonResponseModel(false, 33565, error.message);

    }
  }

  async updateImageUploadStatus(req: StyleStautsReq): Promise<CommonResponseModel> {
    try {
      const data = await this.fileRepo.update({ id: req.id }, { status: TrimCardStatusEnum.DELETED })
      if (data.affected != 0) {
        return new CommonResponseModel(true, 1, 'Image Deleted', data)
      }
    }
    catch (err) {
      throw err
    }
  }

  async getAllCarharttImages(): Promise<CommonResponseModel> {
    try {
      const query = `SELECT ip.id,ip.file_name AS fileName,ip.file_path AS filePath,
                     ip.original_name AS originalName,ip.modified_original_name AS modifiedOriginalName,ip.status
                     FROM image_upload ip
                     WHERE ip.status='OPEN'
                     `
      const result = await this.fileRepo.query(query);
      if (result) {
        return new CommonResponseModel(true, 12345, 'Data Retrived Successfully', result)
      }
      else {
        return new CommonResponseModel(false, 67890, 'Data Retrived Successfully', result)
      }
    }
    catch (err) {
      return err
    }
  }

  async saveCarharttData(req: any): Promise<CommonResponseModel> {
    try {
      const entities = [];
      const measurementDataRecords = [
        ...(req.combinedProductPlusColor.combinedFabricColorHeaders || []),
        ...(req.combinedProductPlusColor.combinedLabelColorHeaders || []),
        ...(req.combinedProductPlusColor.combinedPackingColorHeaders || [])
      ];
      for (const rec of measurementDataRecords) {
        const entity = new MeasurementDataShahiCarharttEntity();
        entity.createdUser = "admin";
        entity.measurementData = rec;
        entity.styleData = req.styleData;
        entity.seasonData = req.seasonData;
        entity.submitDate = req.submitDate;
        entities.push(entity);
      }
      const saveRecords = await this.ColorCarharttRepo.save(entities);
      if (saveRecords) {
        return new CommonResponseModel(true, 11, 'Saved successfully');
      } else {
        return new CommonResponseModel(false, 11, 'Save Failed');
      }
    } catch (error) {
      console.log(error);
      return new CommonResponseModel(false, 11, 'Error While Saving');
    }
  }

  async createCarharttData(dto: StylesDto): Promise<CommonResponseModel> {
    const transactionalManager = new GenericTransactionManager(this.dataSource)
    try {
      await transactionalManager.startTransaction();
      const { combinedFabricColorHeaders, combinedLabelColorHeaders, combinedPackingColorHeaders } = dto.combinedProductPlusColor
      const entities = new StylesEntity;
      entities.id = dto.id
      entities.dropDown = dto.dropDown
      entities.styleData = dto.styleData
      entities.seasonData = dto.seasonData
      entities.submitDate = dto.submitDate
      entities.styleDescription = dto.styleDescription
      entities.techPack = dto.techPack
      entities.status = TrimCardStatusEnum.OPEN;
      const saveRecords = await transactionalManager.getRepository(StylesEntity).save(entities);
      let fabricRecords = []
      for (const fabric of combinedFabricColorHeaders) {
        const measurementEntity = new MeasurementDataEntity()
        measurementEntity.styles = saveRecords
        measurementEntity.measurementData = fabric;
        measurementEntity.trimCard = WfxCarharttEnum.FABRIC
        fabricRecords.push(measurementEntity)
      };
      await transactionalManager.getRepository(MeasurementDataEntity).save(fabricRecords);
      let labelRecords = []
      for (const fabric of combinedLabelColorHeaders) {
        const measurementEntity = new MeasurementDataEntity()
        measurementEntity.styles = saveRecords
        measurementEntity.measurementData = fabric;
        measurementEntity.trimCard = WfxCarharttEnum.LABEL
        labelRecords.push(measurementEntity)
      };
      await transactionalManager.getRepository(MeasurementDataEntity).save(labelRecords);
      let packingRecords = []
      for (const fabric of combinedPackingColorHeaders) {
        const measurementEntity = new MeasurementDataEntity()
        measurementEntity.styles = saveRecords
        measurementEntity.measurementData = fabric;
        measurementEntity.trimCard = WfxCarharttEnum.PACKAGINGTRIMS
        packingRecords.push(measurementEntity)
      };
      await transactionalManager.getRepository(MeasurementDataEntity).save(packingRecords);
      await transactionalManager.completeTransaction();
      return new CommonResponseModel(true, 1, 'Saved successfully', saveRecords);
    } catch (error) {
      console.log(error);
      await transactionalManager.releaseTransaction();
      return new CommonResponseModel(false, 11, 'Error While Saving');
    }
  }

  async updateTrimCardView(req: TrimCardUpdateReq): Promise<CommonResponseModel> {
    let query = `UPDATE styles_entity
                 sET submit_date="${req.submitDate}",
                    season = "${req.seasonData}",
                    style = "${req.styleData}",
                    style_description="${req.styleDescription}",
                    factory="${req.factory}",
                    approval_type="${req.approvalType}",
                    state="${req.state}",
                    factory_merchandiser_sign="${req.factoryMerchandiserSign}",
                    comments="${req.comments}",
                    approved_by="${req.approvedBy}"
                    WHERE id=${req.id}`
    const result = await this.styleRepo.query(query)
    if (result.affected != 0) {
      return new CommonResponseModel(true, 1, "Trim Card Updated", result)
    } else {
      return new CommonResponseModel(false, 0, "Fail")
    }
  }

  async getAllCarharttMeasurementData(): Promise<CommonResponseModel> {
    try {
      const data = await this.styleRepo.getAllCarharttMeasurementData();
      for (const ele of data) {
        const s = new StylesEntity();
        s.id = ele.id;

        const fabricData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.FABRIC } });
        for (const item of fabricData) {
          ele.combinedProductPlusColor.combinedFabricColorHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData))
        }

        const labelData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.LABEL } });
        for (const item of labelData) {
          ele.combinedProductPlusColor.combinedLabelColorHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData))
        }

        const packingData = await this.measurementRepo.find({ relations: ['styles'], where: { styles: s, trimCard: WfxCarharttEnum.PACKAGINGTRIMS } });
        for (const item of packingData) {
          ele.combinedProductPlusColor.combinedPackingColorHeaders.push(new MeasurementDataReq(item.id, item.styles.id, item.measurementData))
        }
      }
      return new CommonResponseModel(true, 1, 'Data Retrived', data)
    }
    catch (error) {
      throw error;
    }
  }

  async getStylesFileName(req: any): Promise<CommonResponseModel> {
    let query = ` SELECT s.id,s.pdf_file_name AS fileName,s.status   FROM styles_entity s`
    const result = await this.styleRepo.query(query)
    if (result) {
      return new CommonResponseModel(true, 1, "Success", result)
    } else {
      return new CommonResponseModel(false, 0, "Fail")
    }
  }

  async updateStatusStyle(req: StyleStautsReq): Promise<CommonResponseModel> {
    try {
      const data = await this.styleRepo.update({ id: req.id }, { status: TrimCardStatusEnum.DELETED })
      if (data) {
        return new CommonResponseModel(true, 1, 'Status Updated', data)
      }
    }
    catch (err) {
      throw err
    }
  }

  async updateTrimCardFileSave(filePath: string, filename: string, id: number, originalname: string): Promise<CommonResponseModel> {
    try {
      const filePathUpdate = await this.styleRepo.update(
        { id: id },
        { filePath: filePath, fileName: filename, originalname: originalname },
      );
      // console.log(filePath, "filePath");
      // console.log(filename, "fileName");
      // console.log(filePathUpdate, "filePathUpdate")
      if (filePathUpdate.affected > 0) {
        return new CommonResponseModel(true, 11, 'Uploaded successfully', filePathUpdate);
      }
      else {
        return new CommonResponseModel(false, 11, 'Uploaded failed', filePathUpdate);
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  async getImageNames(req: any): Promise<CommonResponseModel> {
    try {
      const data = await this.imagesRepo.find()
      if (data) {
        return new CommonResponseModel(true, 1, 'Data retrived Successfully', data)
      } else {
        return new CommonResponseModel(false, 0, 'No Data Found', [])
      }
    } catch (err) {
      throw err
    }
  }

  async saveBuyer(req: any, isUpdate: boolean): Promise<CommonResponseModel> {
    if (!isUpdate) {
      const existingBuyer = await this.buyerRepo.findOne({ where: { buyer: req.buyer } });
      if (existingBuyer) {
        return new CommonResponseModel(false, 0, "Buyer Already Exists");
      }
    }
    const entity = new BuyerEntity()
    entity.buyer = req.buyer
    if (isUpdate) {
      entity.id = req.id
      entity.updatedUser = req.updatedUser
    }
    else {
      entity.createdUser = req.createdUser
    }
    const saveBuyer = await this.buyerRepo.save(entity)
    if (saveBuyer) {
      return new CommonResponseModel(true, 1, "Buyer Created", saveBuyer)
    } else {
      return new CommonResponseModel(false, 0, "Fail")
    }
  }

  async buyerFileSave(filePath: string, filename: string, id: number, originalname: string): Promise<CommonResponseModel> {
    try {
      const filePathUpdate = await this.buyerRepo.update(
        { id: id },
        { filePath: filePath, fileName: filename, originalname: originalname },
      );
      if (filePathUpdate.affected > 0) {
        return new CommonResponseModel(true, 11, 'Uploaded successfully', filePath);
      }
      else {
        return new CommonResponseModel(false, 11, 'Uploaded failed', filePath);
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  async getAllBuyers(req?: any): Promise<CommonResponseModel> {
    let query = `SELECT id,buyer,file_path AS filePath,file_name AS fileName,original_name AS originalname
               FROM buyer_master`
    const result = await this.buyerRepo.query(query)
    if (result) {
      return new CommonResponseModel(true, 1, "Success", result)
    } else {
      return new CommonResponseModel(false, 0, "Fail")
    }
  }

  async saveParameter(req: any): Promise<CommonResponseModel> {
    try {
      const entities = [];
      for (const rec of req.parameters) {
        const data = new ParameterEntity()
        data.buyer = req.buyer;
        data.parameter = rec.parameter;
        entities.push(data)
      }
      await this.parameterRepo.save(entities);
      return new CommonResponseModel(true, 1, 'Parameter Created', entities)
    } catch (err) {
      return err
    }
  }

  async getAllParameters(): Promise<CommonResponseModel> {
    let query = `SELECT b.buyer,
                 GROUP_CONCAT(p.parameter ORDER BY p.id SEPARATOR '+ ') AS parameter
                 FROM parameter_master p
                 LEFT JOIN buyer_master b ON b.id = p.buyer
                 GROUP BY b.buyer`
    const result = await this.parameterRepo.query(query)
    if (result) {
      return new CommonResponseModel(true, 1, "Success", result)
    } else {
      return new CommonResponseModel(false, 0, "Fail")
    }
  }

  async updateImageUpload(req?: ImageUplaodReq): Promise<CommonResponseModel> {
    console.log(req, "req");
    try {
      let query =
        ` UPDATE image_upload
          SET modified_original_name ='${req.modifiedOriginalName}'
          WHERE id=${req.id} `
      const result = await this.fileRepo.query(query)
      if (result) {
        return new CommonResponseModel(true, 1, 'Updated Successfully', result)
      }
    }
    catch (err) {
      return new CommonResponseModel(false, 0, err.message)
    }
  }

  async TrimCardImageSave(filesData: any[], createdUser: string, id: number, buyer: any, parameter: any): Promise<CommonResponseModel> {
    try {
      const fileEntities: WfxImageUploadEntity[] = [];
      filesData.forEach((file) => {
        const fileObj = new WfxImageUploadEntity();
        fileObj.id = id;
        fileObj.fileName = file.filename;
        fileObj.originalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.modifiedOriginalName = file.originalname.replace(/\.png|\.jpg|\.jpeg|\.PNG|\.JPG|\.JPEG/g, "");
        fileObj.filePath = file.path;
        fileObj.createdUser = createdUser;
        fileEntities.push(fileObj);
      });
      const save = await this.fileRepo.save(fileEntities);
      return new CommonResponseModel(true, 65433, "FileUploaded Successfully");
    } catch (error) {
      return new CommonResponseModel(false, 33565, error.message);
    }
  }

  // async saveUnitTwelveExcelData(req: any): Promise<CommonResponseModel> {
  //   console.log(req, "req8888888888888");
  //   try {
  //     const entities = [];
  //     for (const rec of req) {
  //       const data = new UnitTweleveExcelDataEntity();
  //       data.soNumber = rec['SO Number'];
  //       data.placeOfSupply = rec['Place of Supply'];
  //       data.shipToCustomer = rec['Ship To Customer'];
  //       data.customerPo = rec['Customer PO'];
  //       data.itemDescription = rec['Item Description'];
  //       data.hsnCode = rec['HSN Code'];
  //       data.Qty = rec['Qty'];
  //       data.unitPrice = rec['Unit Price'];
  //       data.uom = rec['UOM'];
  //       data.netAmount = rec['Net Amount INR'];
  //       data.color = rec['Color'];
  //       data.size = rec['Size'];
  //       data.qtyWiseData = rec['Qty Wise Data'];
  //       data.tax = rec['Tax'];
  //       entities.push(data);
  //     }
  //     await this.unittweleveexcelRepo.save(entities);
  //     return new CommonResponseModel(true, 1, 'Saved Successfully', entities);
  //   } catch (err) {
  //     return new CommonResponseModel(false, 0, 'Error saving data', err);
  //   }
  // }
  async saveUnitTwelveExcelData(req: any): Promise<CommonResponseModel> {
    console.log(req, "req8888888888888");
    try {
      const entities = [];
      const compressedArrayOfData = Array.isArray(req[0]) ? req.flat() : req;

      for (const rec of compressedArrayOfData) {
        const data = new UnitTweleveExcelDataEntity();
        data.soNumber = rec['SO Number'];
        data.placeOfSupply = rec['Place of Supply'];
        data.shipToCustomer = rec['Ship To Customer'];
        data.customerPo = rec['Customer PO'];
        data.itemDescription = rec['Item Description'];
        data.hsnCode = rec['HSN Code'];
        data.Qty = rec['Qty'];
        data.unitPrice = rec['Unit Price'];
        data.uom = rec['UOM'];
        data.netAmount = rec['Net Amount INR'];
        data.color = rec['Color'];
        data.size = rec['Size'];
        data.qtyWiseData = rec['Qty Wise Data'];
        data.tax = rec['Tax'];
        entities.push(data);
      }

      await this.unittweleveexcelRepo.save(entities);
      return new CommonResponseModel(true, 1, 'Saved Successfully', entities);
    } catch (err) {
      return new CommonResponseModel(false, 0, 'Error saving data', err);
    }
  }

  async getAllPdfsData(): Promise<CommonResponseModel> {
    try {
      let query = `SELECT uted.id AS id,
                   uted.so_number AS soNumber,uted.place_of_supply AS placeOfSupply,uted.ship_to_customer AS shipToCustomer,
                   uted.customer_po AS customerPo,uted.item_description AS itemDescription,uted.hsn_code AS hsnCode,
                   uted.qty AS qty,uted.unit_price AS unitPrice,uted.uom AS uom,
                   uted.net_amount AS netAmount,uted.color AS color,uted.size AS size,
                   uted.qty_wise_data AS qtyWiseData,uted.tax as tax,uted.is_active AS isActive,uted.created_at AS createdAt,
                   uted.created_user AS createdUser
                   FROM unit_twelve_excel uted
                    `
      const result = await this.unittweleveexcelRepo.query(query)
      if (result) {
        return new CommonResponseModel(true, 123, 'Data Retrived', result)
      }
    }
    catch (err) {
      throw err
    }
  }


  async getAllVersions(req: WFXIdReqDto): Promise<CommonResponseModel> {
    const data = await this.versionsApparelRepo.findOne({ select: ['rawData'], where: { id: req.wfxId } });
    if (data) {
      data.rawData = JSON.parse(data.rawData)
      return new CommonResponseModel(true, 55612, "Data Retrieved Successfully", data.rawData)
    } else {
      return new CommonResponseModel(false, 21655, "No Data Found")
    }
  }

  async getVersionsGridData(req: WFXIdReqDto): Promise<CommonResponseModel> {
    const apparelEn = new ApparelArticleMaster();
    apparelEn.id = req.wfxId
    const data = await this.versionsApparelRepo.find({ select: ['approvalStatus', 'role', 'bomNumber', 'id', 'created', 'status', 'techPack', 'department', 'brand'], where: { apparelArticleId: apparelEn } })
    if (data.length) {
      return new CommonResponseModel(true, 54545, "Data Retrieved Successfully", data)
    } else {
      return new CommonResponseModel(false, 96325, "Data Not Found", [])
    }
  }



  async createVersions(req: any): Promise<CommonResponseModel> {
    const transactionalManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionalManager.startTransaction();
      let internalMessage;
      const findVersionRecord = await this.versionsApparelRepo.findOne({ where: { techPack: req.articleApparelMaster[0]['Tech Pack'], role: req.articleApparelMaster[0]['role'] } })
      if (findVersionRecord) {
        const apparelAMEntity = new ApparelArticleMasterVersions();
        apparelAMEntity.id = findVersionRecord.id;
        await transactionalManager.getRepository(FabricTrimsMasterVersions).delete({ versionApparelArticleId: apparelAMEntity });
        await transactionalManager.getRepository(MeasurementChart2TVersions).delete({ versionApparelArticleId: apparelAMEntity });
        await transactionalManager.getRepository(MeasurementChartMonthsVersions).delete({ versionApparelArticleId: apparelAMEntity });
        await transactionalManager.getRepository(ApparelArticleMasterVersions).delete({ techPack: req.articleApparelMaster[0]['Tech Pack'], role: req.articleApparelMaster[0]['role'] })
        internalMessage = 'Version Updated Successfully'
      } else {
        internalMessage = 'Version Created Successfully'
      }
      const apparel = this.WFXAdapter.convertVersionsArticleApparelMasterDtoToEntity(req.articleApparelMaster[0], JSON.stringify(req))
      const saveApparel = await transactionalManager.getRepository(ApparelArticleMasterVersions).save(apparel);
      const saveApparelId = saveApparel.id
      const fabric = this.WFXAdapter.convertVersionsFabricDtoToEntity(req.fabricData, ArticleTextileType.FABRICMASTER, saveApparelId)
      await transactionalManager.getRepository(FabricTrimsMasterVersions).save(fabric);
      const trim = this.WFXAdapter.convertVersionsFabricDtoToEntity(req.trimData, ArticleTextileType.TRIMMASTER, saveApparelId)
      await transactionalManager.getRepository(FabricTrimsMasterVersions).save(trim);
      const measurement2TData = this.WFXAdapter.convertVersionsMeasurement2TDataDtoEntity(req.measurement2TData, saveApparelId);
      await transactionalManager.getRepository(MeasurementChart2TVersions).save(measurement2TData);
      const measurement6MonthsData = this.WFXAdapter.convertVersionsMeasurement6MonthsDataDtoToEntity(req.measurement6MonthsData, saveApparelId);
      await transactionalManager.getRepository(MeasurementChartMonthsVersions).save(measurement6MonthsData);
      await transactionalManager.completeTransaction();
      return new CommonResponseModel(true, 5685, internalMessage);
    } catch (error) {
      await transactionalManager.releaseTransaction();
      return new CommonResponseModel(false, 8698, error.message);
    }
  }

  async deleteArticleApparelMaster(apparelId: number, deleteVersion?: boolean): Promise<CommonResponseModel> {
    const transactionalManager = new GenericTransactionManager(this.dataSource);
    try {
      await transactionalManager.startTransaction();
      const apparelAMEntity = new ApparelArticleMaster();
      apparelAMEntity.id = apparelId;
      if (deleteVersion) {
        const versionsApparelId = await this.versionsApparelRepo.findOne({ select: ['id'], where: { apparelArticleId: apparelAMEntity } })
        const versionsApparelAMEntity = new ApparelArticleMasterVersions();
        versionsApparelAMEntity.id = versionsApparelId.id;
        await transactionalManager.getRepository(FabricTrimsMasterVersions).delete({ versionApparelArticleId: versionsApparelAMEntity });
        await transactionalManager.getRepository(MeasurementChart2TVersions).delete({ versionApparelArticleId: versionsApparelAMEntity });
        await transactionalManager.getRepository(MeasurementChartMonthsVersions).delete({ versionApparelArticleId: versionsApparelAMEntity });
        await transactionalManager.getRepository(ApparelArticleMasterVersions).delete({ id: versionsApparelId.id });
      }
      await transactionalManager.getRepository(FabricTrimsMaster).delete({ apparelArticleId: apparelAMEntity });
      await transactionalManager.getRepository(MeasurementChart2T).delete({ apparelArticleId: apparelAMEntity });
      await transactionalManager.getRepository(MeasurementChartMonths).delete({ apparelArticleId: apparelAMEntity });
      await transactionalManager.getRepository(ApparelArticleMaster).delete({ id: apparelId });
      await transactionalManager.completeTransaction()
      return new CommonResponseModel(true, 9695, "Deleted Successfully")
    } catch (error) {
      await transactionalManager.releaseTransaction();
      return new CommonResponseModel(false, 89365, error.message);
    }


  }



  async saveTechPackData(req: any): Promise<CommonResponseModel> {
    const transactionalManager = new GenericTransactionManager(this.dataSource);
    try {
      if (!req?.articleApparelMaster?.[0]?.id) {
        const findDuplicateRecords = await this.apparelAMrepo.count({ where: { techPack: req.articleApparelMaster[0]['Tech Pack'], role: req.articleApparelMaster[0]['role'] } })
        if (findDuplicateRecords) {
          return new CommonResponseModel(false, 6525, "Tech Pack Data Already Exist")
        }
      } else {
        return await this.createVersions(req)
      }
      await transactionalManager.startTransaction();
      const convertToDate = (dateString: string): Date => {
        const [month, day, year] = dateString.split('/');
        return new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`);
      };
      const convertArticleApparelMasterDtoToEntity = this.WFXAdapter.convertArticleApparelMasterDtoToEntity(req.articleApparelMaster[0], JSON.stringify(req))
      convertArticleApparelMasterDtoToEntity.created = convertToDate(req.articleApparelMaster[0]['Created']);
      convertArticleApparelMasterDtoToEntity.modified = convertToDate(req.articleApparelMaster[0]['Modified']);
      const saveArticleApparelMaster = await transactionalManager.getRepository(ApparelArticleMaster).save(convertArticleApparelMasterDtoToEntity)
      const fabricDtoToEntity = this.WFXAdapter.convertFabricDtoToEntity(req.fabricData, ArticleTextileType.FABRICMASTER, saveArticleApparelMaster.id)
      await transactionalManager.getRepository(FabricTrimsMaster).save(fabricDtoToEntity)
      const trimDataDtoToEntity = this.WFXAdapter.convertFabricDtoToEntity(req.trimData, ArticleTextileType.TRIMMASTER, saveArticleApparelMaster.id)
      await transactionalManager.getRepository(FabricTrimsMaster).save(trimDataDtoToEntity)
      const measurement2TData = this.WFXAdapter.convertMeasurement2TDataDtoEntity(req.measurement2TData, convertArticleApparelMasterDtoToEntity.id);
      await transactionalManager.getRepository(MeasurementChart2T).save(measurement2TData);
      const measurement6MonthsData = this.WFXAdapter.convertMeasurement6MonthsDataDtoToEntity(req.measurement6MonthsData, convertArticleApparelMasterDtoToEntity.id);
      await transactionalManager.getRepository(MeasurementChartMonths).save(measurement6MonthsData);
      await transactionalManager.completeTransaction()
      return new CommonResponseModel(true, 3654, "Created Successfully")
    } catch (error) {
      await transactionalManager.releaseTransaction();
      return new CommonResponseModel(false, 6514, error.message)
    }
  }



  async getTechPackGridData(req: WFXStatusWiseReqDto): Promise<CommonResponseModel> {
    let status = [];
    if (req.role === WFXRolesEnum.HEAD_OF_TECHNICAL) {
      if (req.status === WFXStatusEnum.APPROVED) {
        status = Array.from(Object.values(StatusApprovalsEnum)).filter(rec => ![StatusApprovalsEnum.PENDING_WITH_HEAD_OF_TECHNICAL, StatusApprovalsEnum.HEAD_OF_TECHNICAL_REJECTED].includes(rec));
      }
      if (req.status === WFXStatusEnum.REJECTED) {
        status = [StatusApprovalsEnum.HEAD_OF_TECHNICAL_REJECTED]
      }
      if (req.status === WFXStatusEnum.PENDING_FOR_APPROVAL) {
        status = [StatusApprovalsEnum.PENDING_WITH_HEAD_OF_TECHNICAL]
      }
    }

    if (req.role === WFXRolesEnum.HEAD_OF_QUALITY) {
      if (req.status === WFXStatusEnum.APPROVED) {
        status = Array.from(Object.values(StatusApprovalsEnum)).filter(rec => ![StatusApprovalsEnum.PENDING_WITH_HEAD_OF_TECHNICAL, StatusApprovalsEnum.HEAD_OF_TECHNICAL_REJECTED, StatusApprovalsEnum.HEAD_OF_QUALITY_REJECTED, StatusApprovalsEnum.PENDING_WITH_HEAD_OF_QUALITY].includes(rec));
      }
      if (req.status === WFXStatusEnum.REJECTED) {
        status = [StatusApprovalsEnum.HEAD_OF_QUALITY_REJECTED]
      }
      if (req.status === WFXStatusEnum.PENDING_FOR_APPROVAL) {
        status = [StatusApprovalsEnum.PENDING_WITH_HEAD_OF_QUALITY]
      }
    }

    if (req.role === WFXRolesEnum.SAMPLE_ROOM_MANAGER) {
      if (req.status === WFXStatusEnum.APPROVED) {
        status = Array.from(Object.values(StatusApprovalsEnum)).filter(rec => ![StatusApprovalsEnum.PENDING_WITH_HEAD_OF_TECHNICAL, StatusApprovalsEnum.HEAD_OF_TECHNICAL_REJECTED, StatusApprovalsEnum.HEAD_OF_QUALITY_REJECTED, StatusApprovalsEnum.PENDING_WITH_HEAD_OF_QUALITY, StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_REJECTED, StatusApprovalsEnum.PENDING_WITH_SAMPLE_ROOM_MANAGER].includes(rec));
      }
      if (req.status === WFXStatusEnum.REJECTED) {
        status = [StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_REJECTED]
      }
      if (req.status === WFXStatusEnum.PENDING_FOR_APPROVAL) {
        status = [StatusApprovalsEnum.PENDING_WITH_SAMPLE_ROOM_MANAGER]
      }
    }

    if (req.role === WFXRolesEnum.WAREHOUSE_MANAGER) {
      if (req.status === WFXStatusEnum.APPROVED) {
        status = Array.from(Object.values(StatusApprovalsEnum)).filter(rec => ![StatusApprovalsEnum.PENDING_WITH_HEAD_OF_TECHNICAL, StatusApprovalsEnum.HEAD_OF_TECHNICAL_REJECTED, StatusApprovalsEnum.HEAD_OF_QUALITY_REJECTED, StatusApprovalsEnum.PENDING_WITH_HEAD_OF_QUALITY, StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_REJECTED, StatusApprovalsEnum.PENDING_WITH_SAMPLE_ROOM_MANAGER].includes(rec));
      }
      if (req.status === WFXStatusEnum.REJECTED) {
        status = [StatusApprovalsEnum.SAMPLE_ROOM_MANAGER_REJECTED]
      }
      if (req.status === WFXStatusEnum.PENDING_FOR_APPROVAL) {
        status = [StatusApprovalsEnum.PENDING_WITH_SAMPLE_ROOM_MANAGER]
      }
    }


    const data = await this.apparelAMrepo.find({ select: ['approvalStatus', 'role', 'bomNumber', 'id', 'created', 'status', 'techPack', 'department'], where: { approvalStatus: In([...status]), }, order: { createdAt: -1 } });
    if (data.length) {
      return new CommonResponseModel(true, 6155, "Data Retrieved Successfully", data)
    } else {
      return new CommonResponseModel(false, 9545, "No Data Found")
    }
  }




  async getAllTechPackData(req: WFXIdReqDto): Promise<CommonResponseModel> {
    if (!req.wfxId) {
      return new CommonResponseModel(false, 21655, "Please Provide Valid Tech Pack Id")
    }
    const data = await this.apparelAMrepo.findOne({ select: ['rawData'], where: { id: req.wfxId } });
    if (data) {
      data.rawData = JSON.parse(data.rawData)
      return new CommonResponseModel(true, 55612, "Data Retrieved Successfully", data.rawData)
    } else {
      return new CommonResponseModel(false, 21655, "No Data Found")
    }
  }


  async getAllTechPckAndVersionsData(req: WFXAndVersionsIdReqDto): Promise<CommonResponseModel> {
    try {
      const originalReq = new WFXIdReqDto(req.originalId);
      const versionReq = new WFXIdReqDto(req.versionsId);
      const originalData = (await this.getAllTechPackData(originalReq)).data;
      const versionsData = (await this.getAllVersions(versionReq)).data;
      const versionsObj = {
        articleApparelMasterData: versionsData.articleApparelMaster,
        measurementChart2TDatasource: versionsData.measurement2TData,
        measurementChart6to12MonthsDatasource: versionsData.measurement6MonthsData,
        articleTextileFabricMatserDataSource: [versionsData.fabricData],
        articleTextileTrimMatserDataSource: [versionsData.trimData],
        id: req.versionsId
      };

      const originalObj = {
        apparelMatserData: originalData.articleApparelMaster,
        dataWith2T: originalData.measurement2TData,
        dataWithMonths: originalData.measurement6MonthsData,
        fabricData: [originalData.fabricData],
        trimData: [originalData.trimData],
        id: req.originalId
      };

      return new CommonResponseModel(true, 9554, "Data Retrieved Successfully", { originalData: originalObj, versionsData: versionsObj })
    } catch (error) {
      return new CommonResponseModel(false, 64516, error.message)
    }
  }

}